import React from 'react';
import { Link } from 'react-router-dom';
import { BarChart3Icon, DollarSignIcon, CalendarIcon, TrendingUpIcon, UsersIcon, FileTextIcon } from 'lucide-react';
import Card from '../components/Card';
import Button from '../components/Button';
const MSMEDashboard = () => {
  return <div data-id="element-2343">
      <div className="mb-6" data-id="element-2344">
        <h1 className="text-2xl font-bold text-secondary mb-2" data-id="element-2345">
          MSME Dashboard
        </h1>
        <p className="text-neutral-400" data-id="element-2346">
          Manage your business funding and community engagement
        </p>
      </div>
      {/* MSME Profile Section */}
      <section className="mb-8" data-id="element-2347">
        <Card className="bg-white" data-id="element-2348">
          <div className="flex flex-col md:flex-row md:items-center" data-id="element-2349">
            <div className="flex-1" data-id="element-2350">
              <div className="flex items-center mb-4" data-id="element-2351">
                <div className="w-16 h-16 bg-primary rounded-full flex items-center justify-center text-white text-2xl font-bold mr-4" data-id="element-2352">
                  AC
                </div>
                <div data-id="element-2353">
                  <h2 className="text-xl font-bold" data-id="element-2354">Amani Cafe</h2>
                  <p className="text-sm text-neutral-400" data-id="element-2355">
                    Coffee Shop • Kuala Lumpur
                  </p>
                </div>
              </div>
              <div className="grid grid-cols-1 md:grid-cols-3 gap-4 mb-4" data-id="element-2356">
                <div className="p-3 bg-neutral-50 rounded-lg" data-id="element-2357">
                  <div className="text-sm text-neutral-400 mb-1" data-id="element-2358">
                    Business Maturity
                  </div>
                  <div className="font-medium" data-id="element-2359">3+ Years</div>
                </div>
                <div className="p-3 bg-neutral-50 rounded-lg" data-id="element-2360">
                  <div className="text-sm text-neutral-400 mb-1" data-id="element-2361">
                    Monthly Revenue
                  </div>
                  <div className="font-medium" data-id="element-2362">RM 45,000</div>
                </div>
                <div className="p-3 bg-neutral-50 rounded-lg" data-id="element-2363">
                  <div className="text-sm text-neutral-400 mb-1" data-id="element-2364">Employees</div>
                  <div className="font-medium" data-id="element-2365">8 Team Members</div>
                </div>
              </div>
            </div>
            <div className="md:ml-6 mt-4 md:mt-0" data-id="element-2366">
              <div className="bg-neutral-50 p-4 rounded-lg" data-id="element-2367">
                <h3 className="font-medium mb-2" data-id="element-2368">Profile Completion</h3>
                <div className="w-full bg-neutral-200 rounded-full h-2.5 mb-2" data-id="element-2369">
                  <div className="bg-primary h-2.5 rounded-full" style={{
                  width: '85%'
                }} data-id="element-2370"></div>
                </div>
                <div className="text-sm text-neutral-400" data-id="element-2371">85% Complete</div>
                <Button variant="outline" size="sm" className="mt-3" data-id="element-2372">
                  Complete Profile
                </Button>
              </div>
            </div>
          </div>
        </Card>
      </section>
      {/* Capital Raising Hub */}
      <section className="mb-8" data-id="element-2373">
        <h2 className="text-xl font-bold mb-4" data-id="element-2374">Capital Raising Hub</h2>
        <div className="grid grid-cols-1 md:grid-cols-2 gap-6" data-id="element-2375">
          <Card data-id="element-2376">
            <div className="flex items-center mb-4" data-id="element-2377">
              <div className="w-10 h-10 rounded-full bg-primary bg-opacity-10 flex items-center justify-center mr-3" data-id="element-2378">
                <DollarSignIcon className="w-5 h-5 text-primary" data-id="element-2379" />
              </div>
              <div data-id="element-2380">
                <h3 className="font-medium" data-id="element-2381">Sukuk Issuance</h3>
                <p className="text-sm text-neutral-400" data-id="element-2382">
                  Shariah-compliant funding
                </p>
              </div>
            </div>
            <div className="mb-4" data-id="element-2383">
              <div className="flex justify-between text-sm mb-1" data-id="element-2384">
                <span data-id="element-2385">Eligibility Status</span>
                <span className="text-success font-medium" data-id="element-2386">Eligible</span>
              </div>
              <div className="w-full bg-neutral-200 rounded-full h-2.5" data-id="element-2387">
                <div className="bg-success h-2.5 rounded-full" style={{
                width: '100%'
              }} data-id="element-2388"></div>
              </div>
            </div>
            <div className="bg-neutral-50 p-3 rounded-lg mb-4" data-id="element-2389">
              <div className="text-sm font-medium mb-2" data-id="element-2390">
                Available Financing
              </div>
              <div className="text-2xl font-bold text-primary mb-1" data-id="element-2391">
                RM 50,000
              </div>
              <div className="text-xs text-neutral-400" data-id="element-2392">
                6-month term • 18% profit rate
              </div>
            </div>
            <Link to="/demo/sukuk-initiation" data-id="element-2393">
              <Button variant="primary" fullWidth data-id="element-2394">
                Start Sukuk Issuance
              </Button>
            </Link>
          </Card>
          <Card data-id="element-2395">
            <div className="flex items-center mb-4" data-id="element-2396">
              <div className="w-10 h-10 rounded-full bg-secondary bg-opacity-10 flex items-center justify-center mr-3" data-id="element-2397">
                <FileTextIcon className="w-5 h-5 text-secondary" data-id="element-2398" />
              </div>
              <div data-id="element-2399">
                <h3 className="font-medium" data-id="element-2400">My Applications</h3>
                <p className="text-sm text-neutral-400" data-id="element-2401">
                  Track your micro-sukuk applications
                </p>
              </div>
            </div>
            <div className="grid grid-cols-2 gap-3 mb-4" data-id="element-2402">
              <div className="p-3 bg-neutral-50 rounded-lg" data-id="element-2403">
                <div className="text-sm text-neutral-400 mb-1" data-id="element-2404">Active</div>
                <div className="text-xl font-bold text-primary" data-id="element-2405">2</div>
                <div className="text-xs text-neutral-400" data-id="element-2406">Applications</div>
              </div>
              <div className="p-3 bg-warning bg-opacity-5 border border-warning border-opacity-20 rounded-lg" data-id="element-2407">
                <div className="text-sm text-warning mb-1" data-id="element-2408">Action Required</div>
                <div className="text-xl font-bold text-warning" data-id="element-2409">1</div>
                <div className="text-xs text-neutral-400" data-id="element-2410">Pending task</div>
              </div>
            </div>
            <div className="space-y-3 mb-4" data-id="element-2411">
              <div className="flex items-center justify-between text-sm" data-id="element-2412">
                <div className="flex items-center" data-id="element-2413">
                  <div className="w-2 h-2 rounded-full bg-warning mr-2" data-id="element-2414"></div>
                  <span data-id="element-2415">Shariah Review</span>
                </div>
                <span data-id="element-2416">Equipment (RM 25,000)</span>
              </div>
              <div className="flex items-center justify-between text-sm" data-id="element-2417">
                <div className="flex items-center" data-id="element-2418">
                  <div className="w-2 h-2 rounded-full bg-success mr-2" data-id="element-2419"></div>
                  <span data-id="element-2420">Ready to Sign</span>
                </div>
                <span data-id="element-2421">Working Capital (RM 15,000)</span>
              </div>
            </div>
            <Link to="/dashboard/msme-applications" data-id="element-2422">
              <Button variant="outline" fullWidth data-id="element-2423">
                View All Applications
              </Button>
            </Link>
          </Card>
        </div>
      </section>
      {/* Active Sukuk Display */}
      <section className="mb-8" data-id="element-2424">
        <h2 className="text-xl font-bold mb-4" data-id="element-2425">Active Sukuk</h2>
        <Card data-id="element-2426">
          <div className="overflow-x-auto" data-id="element-2427">
            <table className="w-full" data-id="element-2428">
              <thead data-id="element-2429">
                <tr className="text-left border-b border-neutral-100" data-id="element-2430">
                  <th className="pb-3 font-medium text-neutral-400" data-id="element-2431">ID</th>
                  <th className="pb-3 font-medium text-neutral-400" data-id="element-2432">Purpose</th>
                  <th className="pb-3 font-medium text-neutral-400" data-id="element-2433">Amount</th>
                  <th className="pb-3 font-medium text-neutral-400" data-id="element-2434">
                    Issued Date
                  </th>
                  <th className="pb-3 font-medium text-neutral-400" data-id="element-2435">
                    Maturity
                  </th>
                  <th className="pb-3 font-medium text-neutral-400" data-id="element-2436">
                    Repayment
                  </th>
                  <th className="pb-3 font-medium text-neutral-400" data-id="element-2437">Actions</th>
                </tr>
              </thead>
              <tbody data-id="element-2438">
                <tr className="border-b border-neutral-100" data-id="element-2439">
                  <td className="py-3" data-id="element-2440">#SK1001</td>
                  <td className="py-3" data-id="element-2441">Equipment</td>
                  <td className="py-3" data-id="element-2442">RM 25,000</td>
                  <td className="py-3" data-id="element-2443">15 Jan 2025</td>
                  <td className="py-3" data-id="element-2444">15 Dec 2025</td>
                  <td className="py-3" data-id="element-2445">
                    <div className="w-full bg-neutral-200 rounded-full h-2 mb-1" data-id="element-2446">
                      <div className="bg-primary h-2 rounded-full" style={{
                      width: '65%'
                    }} data-id="element-2447"></div>
                    </div>
                    <div className="text-xs" data-id="element-2448">65% Complete</div>
                  </td>
                  <td className="py-3" data-id="element-2449">
                    <Button variant="ghost" size="sm" data-id="element-2450">
                      View
                    </Button>
                  </td>
                </tr>
                <tr data-id="element-2451">
                  <td className="py-3" data-id="element-2452">#SK1002</td>
                  <td className="py-3" data-id="element-2453">Inventory</td>
                  <td className="py-3" data-id="element-2454">RM 15,000</td>
                  <td className="py-3" data-id="element-2455">01 Apr 2025</td>
                  <td className="py-3" data-id="element-2456">31 Mar 2026</td>
                  <td className="py-3" data-id="element-2457">
                    <div className="w-full bg-neutral-200 rounded-full h-2 mb-1" data-id="element-2458">
                      <div className="bg-primary h-2 rounded-full" style={{
                      width: '30%'
                    }} data-id="element-2459"></div>
                    </div>
                    <div className="text-xs" data-id="element-2460">30% Complete</div>
                  </td>
                  <td className="py-3" data-id="element-2461">
                    <Button variant="ghost" size="sm" data-id="element-2462">
                      View
                    </Button>
                  </td>
                </tr>
              </tbody>
            </table>
          </div>
        </Card>
      </section>
      {/* Community Benefit Manager */}
      <section data-id="element-2463">
        <h2 className="text-xl font-bold mb-4" data-id="element-2464">Community Benefit Manager</h2>
        <Card data-id="element-2465">
          <div className="mb-6" data-id="element-2466">
            <h3 className="font-medium mb-2" data-id="element-2467">Active Community Benefits</h3>
            <div className="grid grid-cols-1 md:grid-cols-2 gap-4" data-id="element-2468">
              <div className="border border-neutral-100 rounded-lg p-4" data-id="element-2469">
                <div className="flex justify-between items-start mb-3" data-id="element-2470">
                  <div className="bg-accent bg-opacity-10 text-accent px-2 py-1 rounded text-xs font-medium" data-id="element-2471">
                    Discount Voucher
                  </div>
                  <div className="text-sm text-neutral-400" data-id="element-2472">23 Redeemed</div>
                </div>
                <h4 className="font-medium mb-1" data-id="element-2473">10% Off Any Coffee</h4>
                <p className="text-sm text-neutral-400 mb-3" data-id="element-2474">
                  Valid for all investors
                </p>
                <div className="flex items-center text-xs text-neutral-400" data-id="element-2475">
                  <CalendarIcon className="w-3 h-3 mr-1" data-id="element-2476" />
                  <span data-id="element-2477">Expires: 31 Dec 2025</span>
                </div>
              </div>
              <div className="border border-neutral-100 rounded-lg p-4" data-id="element-2478">
                <div className="flex justify-between items-start mb-3" data-id="element-2479">
                  <div className="bg-primary bg-opacity-10 text-primary px-2 py-1 rounded text-xs font-medium" data-id="element-2480">
                    Green Initiative
                  </div>
                  <div className="text-sm text-neutral-400" data-id="element-2481">
                    45 Participants
                  </div>
                </div>
                <h4 className="font-medium mb-1" data-id="element-2482">Reusable Cup Program</h4>
                <p className="text-sm text-neutral-400 mb-3" data-id="element-2483">
                  Bring your own cup for a free upsize
                </p>
                <div className="flex items-center text-xs text-neutral-400" data-id="element-2484">
                  <UsersIcon className="w-3 h-3 mr-1" data-id="element-2485" />
                  <span data-id="element-2486">Community Impact: High</span>
                </div>
              </div>
            </div>
          </div>
          <div className="flex justify-between items-center" data-id="element-2487">
            <h3 className="font-medium" data-id="element-2488">Create New Benefit</h3>
            <Button variant="accent" size="sm" data-id="element-2489">
              Create Benefit
            </Button>
          </div>
        </Card>
      </section>
    </div>;
};
export default MSMEDashboard;